import './page-card.scss';

import classNames from 'classnames';

interface IProps {
  title: string;
  /** Пояснение под заголовком. */
  description?: string;
  /** Действия справа от заголовка: главное — antd `Button type="primary"`. */
  actions?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

/**
 * Белая карточка раздела во всю ширину страницы — как у списков лизингового кабинета:
 * заголовок с действиями и содержимое. Заголовок прячется, когда его показывает шапка
 * каркаса (средний и узкий экран).
 */
const PageCard: React.FC<IProps> = ({
  title,
  description,
  actions,
  className,
  children
}) => (
  <section className={classNames('page-card', className)}>
    <header
      className={classNames('page-card__header', {
        'page-card__header--title-only': !actions
      })}
    >
      <div className="page-card__heading">
        <h2 className="page-card__title">{title}</h2>
        {description && <p className="page-card__description">{description}</p>}
      </div>
      {actions && <div className="page-card__actions">{actions}</div>}
    </header>
    {children}
  </section>
);

export default PageCard;
